import { Badge, HStack, Text, VStack } from '@elkaso-app/web-design';
import { FiMapPin } from 'react-icons/fi';

interface LocationInfoCellProps {
  name: string;
  address: string | null;
  sourcePlatform: string;
  sourceExternalId: string;
  parentId: number | null;
}

export const LocationInfoCell: React.FC<LocationInfoCellProps> = ({
  name,
  address,
  sourcePlatform,
  sourceExternalId,
  parentId,
}) => (
  <div style={{ height: '100px', display: 'flex', alignItems: 'center', padding: '8px 0' }}>
    <VStack align='start' spacing={1}>
      <HStack spacing={2}>
        <FiMapPin color='#3182CE' size={16} />
        <Text fontWeight='semibold' fontSize='md' color='gray.800' lineHeight='1.2'>
          {name}
        </Text>
        {parentId && (
          <Badge colorScheme='orange' variant='subtle' size='sm'>
            Child Location
          </Badge>
        )}
      </HStack>
      {address && (
        <Text fontSize='sm' color='gray.600' lineHeight='1.3' maxW='300px' whiteSpace='normal' wordBreak='break-word'>
          {address}
        </Text>
      )}
      <HStack spacing={2}>
        <Badge colorScheme='blue' variant='subtle' size='sm'>
          {sourcePlatform}
        </Badge>
        <Text fontSize='xs' color='gray.500'>
          ID: {sourceExternalId}
        </Text>
      </HStack>
    </VStack>
  </div>
);
